var map = {
	"./OMS-logo.png": 31,
	"./OMS-screenshots.jpg": 32,
	"./caftan-ahlam-logo.png": 33,
	"./caftan-ahlam-screenshots.jpg": 34,
	"./franni-logo.png": 35,
	"./franni-screenshots.jpg": 36,
	"./hatom-logo.png": 37,
	"./hatom-screenshots.jpg": 38,
	"./jood-logo.png": 39,
	"./jood-screenshots.jpg": 40,
	"./opentech-logo.png": 41,
	"./opentech-screenshots.jpg": 42,
	"./peer-logo.png": 43,
	"./peer-screenshots.jpg": 16,
	"./satfleet-logo.png": 44,
	"./satfleet-screenshots.jpg": 45,
	"./spotbills-logo.png": 46,
	"./spotbills-screenshots.jpg": 47,
	"./spotbusiness-logo.png": 48,
	"./spotbusiness-screenshots.jpg": 49,
	"./spotfit-logo.png": 50,
	"./spotfit-screenshots.jpg": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;